import { studentI18n } from '@/i18n/studentI18n';
import styles from './ErrorScreen.module.scss';

interface ErrorScreenProps {
  /** Acción del botón. Por defecto recarga la página. */
  onReload?: () => void;
}

/**
 * Pantalla de error a página completa con la marca. Presentacional y sin estado.
 * La usan tanto el `AppErrorBoundary` (errores de render) como el
 * `RouteErrorBoundary` de React Router. Vive fuera del `I18nextProvider`, por
 * eso usa la instancia `studentI18n` directamente.
 */
export function ErrorScreen({ onReload }: ErrorScreenProps) {
  const t = studentI18n.t.bind(studentI18n);
  const handleReload = onReload ?? (() => window.location.reload());

  return (
    <div className={styles.errorScreen} role="alert">
      <div className={styles.errorScreen__content}>
        <img
          className={styles.errorScreen__logo}
          src="/logo.svg"
          alt=""
          aria-hidden
          width={72}
          height={72}
        />
        <h1 className={styles.errorScreen__title}>{t('errors.boundaryTitle')}</h1>
        <p className={styles.errorScreen__body}>{t('errors.boundaryBody')}</p>
        <button type="button" className={styles.errorScreen__button} onClick={handleReload}>
          {t('errors.reload')}
        </button>
      </div>
    </div>
  );
}

export default ErrorScreen;
